import { CSMLAssetSource } from './constants';

export const getAssetSourceOptions = i18n => [
  {
    key: CSMLAssetSource.AIGenerated,
    text: i18n.getString(_TL_('Created')),
    title: i18n.getString(_TL_('Created with Microsoft Advertising')),
  },
  {
    key: CSMLAssetSource.UserUploaded,
    text: i18n.getString(_TL_('Upload')),
    title: i18n.getString(_TL_('Uploaded from computer')),
  },
  {
    key: CSMLAssetSource.Website,
    text: i18n.getString(_TL_('Website')),
    title: i18n.getString(_TL_('Advertiser website')),
  },
  {
    key: CSMLAssetSource.Shutterstock,
    text: i18n.getString(_TL_('Shutterstock')),
    title: i18n.getString(_TL_('Shutterstock')),
  },
  {
    key: CSMLAssetSource.Google,
    text: i18n.getString(_TL_('Imported')),
    title: i18n.getString(_TL_('Imported from Google Ads')),
  },
  {
    key: CSMLAssetSource.Facebook,
    text: i18n.getString(_TL_('Imported')),
    title: i18n.getString(_TL_('Imported from Meta Ads')),
  },
];
